//Library Imports
import React, { Suspense, useEffect } from "react";
import { useSelector } from "react-redux";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

//Local Imports
import CreateNewAutomation from "../CreateAutomation/CreateNewAutomation";
import AutomationOnBoarding from "../OnBoarding/AutomationOnBoarding";
import AutomationListing from "../AutomationListing/AutomationListing";
import { resetSuccessMessage } from "../actions";
import TriggerWrapper from "./TriggerWrapper";
import { CREATE_AUTOMATION, AUTOMATION_NODE } from "../../../constants/types/automationTypes";
import { RootState } from "store";
import { removeGillRoyIcon, addGillRoyIcon } from "utils";

const AutomationHeader = React.lazy(() => import("./AutomationHeader"));

interface IAutomationWrapper {
  page: string;
  tab?: string;
  subtab?: string;
}

const AutomationWrapper: React.FC<IAutomationWrapper> = (props) => {
  // Props
  const { page, tab } = props;

  // Local Variables
  const history = useHistory();
  const path = history.location.pathname;

  //Redux states
  const successMessage = useSelector((state: RootState) => state.automation.success);

  // Component Logic
  useEffect(() => {
    let messageText = successMessage?.payload?.message;
    if (messageText) {
      if (successMessage.type === CREATE_AUTOMATION.UPDATE) {
        message.success(messageText);
      } else if (successMessage.type === AUTOMATION_NODE.COPY) {
        message.info(messageText);
      }
    }
    resetSuccessMessage();
  }, [successMessage.type]);

  useEffect(() => {
    removeGillRoyIcon();
    return () => {
      addGillRoyIcon();
    };
  }, []);

  return (
    <Wrapper>
      <Suspense fallback={<div>Loading...</div>}>
        <AutomationHeader page={page} tab={tab} />
      </Suspense>
      {path.endsWith("/details") ? (
        <CreateNewAutomation />
      ) : path.endsWith("/create") ? (
        <TriggerWrapper />
      ) : (
        <>
          <AutomationOnBoarding />
          <AutomationListing />
        </>
      )}
    </Wrapper>
  );
};

export default AutomationWrapper;

// const WrapperOuter = styled.div`
//   z-index: 9;
// `;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 70px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 50px 65px 0 65px;
  }
  .multiple-btn-actions {
    display: flex;
  }
  .content-inner {
    display: flex;
    align-self: flex-end;
    flex-direction: column;
    background-color: #fff;
    box-sizing: border-box;
    float: right;
    width: calc(100% - 88px);
    min-height: 100vh;
    background-color: #f9f8f6;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: calc(100% - 63px);
    }
    .automation-content-wrapper {
      display: flex;
      flex-wrap: wrap;
      margin: 135px 0px 0 0px;
      position: relative;
      scrollbar-width: thin;
      max-height: calc(100vh - 135px);
      overflow-y: auto;
      scrollbar-color: #001760 #efefef;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 5px;
      }
      /* Track */
      &::-webkit-scrollbar-track {
        background: #fff;
      }
      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #001760;
      }
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 105px;
        max-height: calc(100vh - 105px);
      }
      .automation-content-inner {
        padding: 10px 90px 0 90px;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          padding: 00px 65px 0 65px;
        }
      }
    }
  }
  /* } */
`;
